import { VALID_QUERY_FILTERS } from "../../modules/category/constants/filter-constants";

export function getFilters(query) {
  const updatedQuery = {};
  Object.keys(query).forEach((key) => {
    if (VALID_QUERY_FILTERS.includes(key) && !Array.isArray(query[key])) {
      updatedQuery[key] = [query[key]];
    } else {
      updatedQuery[key] = query[key];
    }
  });
  return updatedQuery;
}
